import { useEffect } from 'react';
import { useLocation } from 'react-router';
import { useFirebaseUser } from '@/hooks/useFirebaseUser';
import { checkAndRotateSession } from '@/utils/activitySession';

/**
 * React hook to trigger activity session check on every route change.
 * Persists sessionId and userId in localStorage, rotates sessionId if inactive for 15 minutes.
 */
export function useRouteActivitySession() {
  const location = useLocation();
  const user = useFirebaseUser();

  useEffect(() => {
    if (user && user.uid) {
      checkAndRotateSession(user.uid);
    }
  }, [location, user, user?.uid]);
}
